<template>
  <div id="app">
    <Top />
    <transition name="slide-fade">
      <router-view class="view" :class="language === 'ar' ? 'direction' : ''" />
    </transition>
    <Bottom />
  </div>
</template>

<script>
import Top from '../src/components/Top'
import Bottom from '../src/components/Bottom'

export default {
  name: 'App',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      language: sessionStorage.getItem('language')
    }
  }
}
</script>

<style>
html {
  overflow-x: hidden;
}
/* Scroll */
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #D7D7D7;
}
::-webkit-scrollbar-thumb:hover {
  background: #C6C6C6;
}
#app {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
h1, h2, h3, h4 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none !important;
}
a:hover {
  text-decoration: none !important;
}
p {
  text-align: left;
}
hr {
  margin-top: 0;
}
.direction p,
.direction h1,
.direction h2,
.direction h3,
.direction h4,
.direction h5,
.direction h6 {
  direction: rtl;
}
.clearfix {
  margin: 15px;
}
.clearfix--min {
  margin: 6px;
}
.clearfix--mid {
  margin: 40px;
}
.clearfix--max {
  margin: 100px;
}
.vuejs-progress-bar {
  display: contents !important;
}
.disclaimer {
  color: #0CA789 !important;
}
.container {
  margin-top: 5vh;
  margin-bottom: 0vh;
  min-width: 100vw;
  min-height: 70vh;
  padding-top: 3.5vh;
  padding-bottom: 4vh;
  background: #E4F9E4 !important;
}
.left {
  float: left !important;
}
.text-center {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
[v-cloak] {
  display: none;
}
summary {
  outline: none;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
    .card {
      margin: 20px;
    }
    .btn-l, .btn-r {
      margin: 10px;
    }
    .img {
      width: 22vw !important;
    }
}
@media screen and (-webkit-min-device-pixel-ratio:0) {
  select,
  textarea,
  input {
    font-size: 16px;
  }
}
@media only screen
and (min-device-width : 375px)
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) {
  .header-wrapper {
    display: block !important;
  }
}
.previous-answer::after {
  content: '\2713';
  float: right;
  margin-left: -10px;
}
.active {
  text-decoration: underline !important;
}
.active::after {
  content: '\2713';
}
.div-loader {
  display: none;
}
.div-loader:after {
  content: " ...";
  animation: dots 1s steps(5, end) infinite;
}
@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}
/* route transition */
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to{
  transform: translateX(10px);
  opacity: 0;
}
/* bootstrap override */
.mark {
  background: #e200008e !important;
  margin: 30px;
  padding: 30px;
  border-radius: 10px;
}
.card {
  padding: 20px;
  border-radius: 10px;
  min-height: 66vh;
  margin-top: 3vh;
  background: #F7FFF7 !important;
}
.btn-primary {
  background: #AAD9C3 !important;
  border: 2px solid #8BB19F !important;
  color: #000;
}
.btn-primary:active {
  background: #B2E3CC !important;
  color: #232C28 !important;
}
.btn-outline-secondary {
  border-color: #06755F !important;
  border-width: 2px;
}
.btn-outline-secondary:not(:disabled):not(.disabled):hover {
  color: #fff !important;
  background: #06755F !important;
}
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.btn-outline-secondary:not(:disabled):not(.disabled):active {
  background: #06755F !important;
}
.navbar-toggler {
  border-color: transparent !important;
}
.btn-link {
  text-decoration: none !important;
  line-height: 5px;
  padding-bottom: 15px;
  color: rgba(0, 0, 0, 0.503);
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue